export default {
    main: {
        title: 'Eligible Providers',
        not_found: 'No eligible providers found',
    },

    buttons: {
        view_more: 'view more',
    },
}
